/**
 * 产品试用申请记录
 */
<template>
  <div class="product">
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item>产品试用申请记录</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card class="box-card">
      <!-- 产品列表 s -->
      <div class="product-table" >

        <!-- 搜索筛选 -->
        <el-form :inline="true" :model="formInline" class="user-search">
          <el-form-item label="申请时间">
            <el-row :gutter="24">

              <el-col :span="12">
                <div>
                  <el-date-picker size="small" v-model="daterange" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" align="left">
                  </el-date-picker>
                </div>
              </el-col>
              <el-col :span="8">
                <div>
                  <!-- <el-input size="small" :clearable="true" v-model="formInline.productName" placeholder="输入产品名称查询"></el-input> -->
                  <el-select
                    v-model="formInline.productId"
                    size="small"
                    style="margin-left: 20px;width: 80%"
                    placeholder="请选择">
                    <el-option
                      v-for="item in productList"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id">
                    </el-option>
                  </el-select>
                </div>
              </el-col>
              <el-col :span="4">
                <div>
                  <el-form-item>
                    <el-button size="mini" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
                  </el-form-item>
                </div>
              </el-col>
            </el-row>

          </el-form-item>

        </el-form>

        <!--列表-->
        <el-table size="small" :data="listData" row-key="item" highlight-current-row v-loading="loading" element-loading-text="拼命加载中" style="width: 100%;">

          <el-table-column prop="customersNeed" label="申请试用产品"align="center">
            <template slot-scope="scope">
              <span >{{scope.row.customersNeed | textFormatter}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="createTime" label="申请时间" align="center">
            <template slot-scope="scope">
              <span >{{scope.row.createTime | formatter}}</span>
            </template>
          </el-table-column>
        </el-table>
        <!-- 分页组件 -->
        <Pagination style="float:right" v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>

      </div>
      <!-- 产品列表 e -->
    </el-card>

  </div>
</template>

<script>
import Pagination from '../../components/Pagination'
import moment from 'moment'

import { ProductApplyList, sysProductList } from '../../api/basisMG'

export default {
  data() {
    return {
      expired: 'expired',
      addDetailShow: false,
      loading: false, //是显示加载
      editFormVisible: false, //控制编辑页面显示与隐藏
      productList: [],
      formInline: {
        page: 1,
        pageSize: 10,
        dateCount: null,
        productId: null,
      },
      daterange:['',  ''],
      listData:[],
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 0
      }
    }
  },
  // 注册组件
  components: {
    Pagination
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {
    this.getdata(this.formInline, this.$route.query.flag)
    this.getProductList()
  },
  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    // 获取列表
    getdata(parameter,flag) {
      this.loading = true 
      var params = {
        page: parameter.page,
        pageSize: parameter.pageSize,
        productId: parameter.productId,
      }
      if(this.daterange[0]){
          const start = moment(this.daterange[0]).format('yyyy-MM-DD 00:00:00')
          params['startTime'] = start
        }
        if(this.daterange[1]){
          const end = moment(this.daterange[1]).format('yyyy-MM-DD 23:59:59')
          params['endTime'] = end
        }
      ProductApplyList(params)
        .then(res => {
          this.loading = false
          if (res.code != 0) {
            this.$message({
              type: 'info',
              message: res.message
            })
          } else {
            this.listData = res.data
            // 分页赋值
            this.pageparm.currentPage = this.formInline.page
            this.pageparm.pageSize = this.formInline.pageSize
            this.pageparm.total = res.maxPage
          }
        })
    },
    // 分页插件事件
    callFather(parm) {
      this.formInline.page = parm.currentPage
      this.formInline.pageSize = parm.pageSize
      this.getdata(this.formInline, null)
    },
    // 搜索事件
    search() {
      this.getdata(this.formInline, null)
    },
    getProductList(){
      sysProductList({page:1,pageSize: 100}).then(res=>{
        if(res.code==0){
          this.productList = res.data
        }
      })
    }
  },
  filters: {
    formatter(value) {
      var a = moment(value).add(8, 'h');
      return a.format('YYYY-MM-DD hh:mm:SS')
    },
    textFormatter(value){
      return value.replace('申请试用产品：','')
    }
  }
}
</script>

<style scoped>
.product-table{
  height: 500px
}
.box-card {
  margin-top: 20px;
}
.expired {
  color: brown;
}
</style>

 
 

 


// WEBPACK FOOTER //
// src/views/goods/ProductApplyRecord.vue